module.exports = __webpack_public_path__ + "img/demo.d2c1b967.svg";